"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var EmailLink_1 = __importDefault(require("atomicComponents/atoms/Text/EmailLink"));
var AccordionSummaryPinkArrow_1 = __importDefault(require("atomicComponents/molecules/Accordion/AccordionSummaryPinkArrow"));
var SuccessMessage_1 = __importDefault(require("atomicComponents/molecules/Alerts/SuccessMessage"));
var Money_1 = __importDefault(require("components/Money"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Accordion_1 = __importDefault(require("shared/components/Accordion"));
var AccordionDetails_1 = __importDefault(require("shared/components/Accordion/AccordionDetails"));
var Divider_1 = __importDefault(require("shared/components/Divider"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var DropzoneInvoices_1 = __importDefault(require("./DropzoneInvoices"));
var SampleData_1 = __importDefault(require("./SampleData"));
var PricingInsights = function (_a) {
    var _b;
    var service = _a.service;
    var _c = __read((0, hooks_1.useSearch)('insights'), 2), isOpenStr = _c[0], setOpen = _c[1];
    var isClicked = (0, hooks_1.useQParam)('request');
    var isOpen = !!isOpenStr;
    var selectInsightRequest = react_1.default.useMemo(function () { return (0, single_1.makeSelectInsightRequestForService)(service.id); }, []);
    var insightRequest = (0, react_redux_1.useSelector)(selectInsightRequest);
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var track = (0, analytics_1.useTracker)();
    (0, hooks_1.useScrollToHashId)(!!insightRequest);
    var name = (_b = service.name) !== null && _b !== void 0 ? _b : 'this tool';
    var _d = __read((0, hooks_1.useSubmitter)('insight_requests', insightRequest === null || insightRequest === void 0 ? void 0 : insightRequest.id, {
        serviceId: service.id,
        companyId: profile.companyId,
        userId: profile.id,
        isRequested: true,
    }), 2), submitInsightRequest = _d[0], isSubmitting = _d[1];
    var totalTransactions = service.transactionsCount;
    var totalCompanies = service.companiesCount;
    var annualSpend = service.totalSpend && (0, jsx_runtime_1.jsx)(Money_1.default, { amount: service.totalSpend, isRounded: true, isShortened: "NEW" });
    var isRequested = insightRequest === null || insightRequest === void 0 ? void 0 : insightRequest.isRequested;
    var requestInsight = function () {
        track('Pricing insights Unlocked', {
            serviceId: service.id,
            serviceName: service.niceName || service.name,
            pricingInsightsExtUrls: service.pricingInsightsExtUrls,
            pricingInsightsTeaserUrl: service.pricingInsightsTeaserUrl,
        });
        submitInsightRequest();
    };
    react_1.default.useEffect(function () {
        if (isClicked) {
            setTimeout(function () { return requestInsight(); }, 50);
        }
        track('Pricing insights Mounted', { serviceId: service.id });
    }, []);
    react_1.default.useEffect(function () {
        if (isOpen) {
            track('Pricing insights Opened', { serviceId: service.id });
        }
    }, [isOpen]);
    if (!(0, react_redux_firebase_1.isLoaded)(insightRequest)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ maxWidth: 667 }, { children: (0, jsx_runtime_1.jsxs)(Accordion_1.default, __assign({ hideBorders: true, expanded: isOpen, onChange: function () { return setOpen(isOpen ? '' : '1'); }, offsetHor: true }, { children: [(0, jsx_runtime_1.jsx)(AccordionSummaryPinkArrow_1.default, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ py: 2, pr: 2 }, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3, mb: 2 }, { children: ["How much should I pay for ", name, "?"] })), totalTransactions && totalCompanies && annualSpend ? ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Discover insights from ", (0, end2end_1.handlePlural)('transaction')(totalTransactions), " from ", ' ', (0, end2end_1.handlePlural)('company')(totalCompanies), " that spend annually ", annualSpend, " on ", name] }))) : ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Discover insights from thousand of transactions from other companies that spend millions on SaaS." })))] })) }), (0, jsx_runtime_1.jsxs)(AccordionDetails_1.default, __assign({ sx: { px: 2 } }, { children: [(0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, my: 2 }, { children: "Access unique pricing insights to negotiate your next renewal. Benchmarks are based on real, verified invoices from other companies like you." })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, mb: 2, fontWeight: 600 }, { children: [name, " Verified Invoices ", totalTransactions && "(".concat(totalTransactions, ")")] })), !isRequested
                            ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SampleData_1.default, { onClick: requestInsight, isSending: isSubmitting }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "inline-flex", alignItems: "center", my: 2 }, { children: [totalTransactions && ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["You\u2019re viewing ", Math.min(3, totalTransactions), " of ", (0, end2end_1.handlePlural)('verified invoice')(totalTransactions), "."] }))), (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", onClick: requestInsight, isSending: isSubmitting }, { children: "Request access to the full list" }))] }))] }))
                            : ((0, jsx_runtime_1.jsx)(SuccessMessage_1.default, { message: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Thank you! We\u2019ve received your request to access ", (0, jsx_runtime_1.jsxs)("strong", { children: [name, "\u2019s Pricing Insights."] }), "You\u2019ll receive an email shortly. If not, get in touch at ", (0, jsx_runtime_1.jsx)(EmailLink_1.default, __assign({ href: "mailto:insights@hudled.com" }, { children: "insights@hudled.com" }))] })) })), (0, jsx_runtime_1.jsx)(Divider_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 4, id: "uploadFiles" }, { children: (0, jsx_runtime_1.jsx)(DropzoneInvoices_1.default, { service: service, insightRequest: insightRequest }) }))] }))] })) })));
};
exports.default = PricingInsights;
